export const AgentState = Object.freeze({
  Offline: 'Offline',
  CallingCustomer: 'CallingCustomer',
  Busy: 'Busy',
  ACW: 'AfterCallWork',
  Available: 'Available',
  FailedConnectAgent: 'FailedConnectAgent',
});
